import React from "react";
import { useTranslation } from "react-i18next";
export default function Event(props) {
  const { t } = useTranslation();
  const {
    title,
    month,
    day,
    time,
    imageSrc,
    module_name,
    bgColor,
    mrn,
    LOADING,
  } = props;
  const monthName = t(`month.${month}`);
  return (
    <div
      className="w-full white-space-nowrap card"
      style={{
        flex: "0 0 calc(49.99% - 10px)",
        padding: "8px !important",
        boxSizing: "border-box",
      }}
    >
      <div className="col flex" style={{ gap: "10px" }}>
        <div
          className={`flex flex-column justify-content-center align-items-center bg-${bgColor} relative`}
          style={{
            width: "6rem",
            height: "5rem",
            borderRadius: "0.5rem",
            boxShadow:
              "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
          }}
        >
          <div className="h-6 w-full bg-blue-600 rounded-t-lg text-white flex justify-content-center align-items-center">
            {month === "Invalid Date" ? LOADING : monthName}
          </div>
          <div className="h-14 w-full rounded-b-lg flex flex-column justify-content-center align-items-center">
            {day !== "NaN" && <strong className="text-3xl">{day}</strong>}
            <span className="text-xs">
              {time === "Invalid Date" ? LOADING : time}
            </span>
          </div>
        </div>
        <div
          className="flex-grow-1 flex flex-column justify-content-center"
          style={{ paddingLeft: "1.25rem !important" }}
        >
          <h4 className="text-xl">{title}</h4>
          <label className="text-sm">
            {module_name ? module_name : LOADING} {mrn ? mrn : ""}
          </label>
        </div>
      </div>
    </div>
  );
}
